import { ConversationRatingFragment } from '@shared/generated/graphql';
import { ConversationRating } from '@shared/types/rating';

export function conversationRatingFromFragment(
  fragment: ConversationRatingFragment
): ConversationRating {
  return {
    id: fragment.id,
    createdAt: new Date(fragment.createdAt),
    userId: fragment.userId,
    starRating: fragment.starRating,
    comments: fragment.comments ?? undefined,
  };
}
